<script setup lang="ts">

const props = defineProps<{artwork: Artwork}>();
const config = useRuntimeConfig();

const imageUrl = computed(() => {
  const _imageUrl = `${config.public.metApiBaseUrl}${props.artwork.images[0]?.url!}`;
  return _imageUrl;
});

</script>
<template>
  <div class="portfolio-item masonry-item" :class="[`cat-${props.artwork.categoria.slug}`]">
    <div class="portfolio-item-content">
      <div class="item-thumbnail" >
        <img :src="imageUrl" :alt="props.artwork.title" style="position: relative;"/>
      </div>
      <div class="portfolio-description">
        <h4>
            <NuxtLink :to="`/artworks/${props.artwork.categoria.slug}/${props.artwork.slug}`">{{ props.artwork.title }}</NuxtLink>
        </h4>
        <ul class="portfolio-category">
          <li>
            <NuxtLink :to="`/artworks/${props.artwork.categoria.slug}`">{{ props.artwork.categoria.title }}</NuxtLink>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
